import { IonPage, IonContent, IonText, IonButton, IonRange } from '@ionic/react'
import InitialConfigHeader from '../header'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInitialConfigExtraProperty } from '../../../redux/reducer/initialConfigSlice'
import '../InitialConfiguration.min.css'
import measures from '../../../settings/measuresConfig'
import { useHistory } from 'react-router'

const HipCircunferencePace = ({ step, totalSteps }) => {
	const history = useHistory()
	const measureIndex = measures.findIndex(
		(measure) => measure.value === 'hips_circumference'
	)
	const [isLoading, setIsLoading] = useState(false)
	const hip_circumference = useSelector(
		(state) =>
			state.initialConfig.extras.hip_circumference ||
			measures[measureIndex].initialValue
	)
	const dispatch = useDispatch()

	const updateInput = (e) => {
		dispatch(
			setInitialConfigExtraProperty({
				key: 'hip_circumference',
				value: e.detail.value,
			})
		)
	}

	const handleSkip = (e) => {
		setIsLoading(true)
		dispatch(
			setInitialConfigExtraProperty({ key: 'hip_circumference', value: null })
		)
		history.push(`/impostazioni-iniziali/${step + 1}`)
		setIsLoading(false)
	}

	const handleSubmit = () => {
		setIsLoading(true)
		history.push(`/impostazioni-iniziali/${step + 1}`)
		setIsLoading(false)
	}

	const handleDecrease = () => {
		const newValue = hip_circumference - measures[measureIndex].step
		dispatch(
			setInitialConfigExtraProperty({
				key: 'hip_circumference',
				value: Math.max(newValue, measures[measureIndex].min),
			})
		)
	}

	const handleIncrease = () => {
		const newValue = hip_circumference + measures[measureIndex].step
		dispatch(
			setInitialConfigExtraProperty({
				key: 'hip_circumference',
				value: Math.min(newValue, measures[measureIndex].max),
			})
		)
	}
	return (
		<IonPage className="initial-configuration">
			<InitialConfigHeader
				step={step}
				totalSteps={totalSteps}
				isLoading={isLoading}
			/>

			<IonContent>
				<h1>Circonferenza fianchi</h1>
				<IonRange
					min={measures[measureIndex].min}
					max={measures[measureIndex].max}
					step={measures[measureIndex].step}
					pinFormatter={(value) =>
						value.toFixed(2).replace('.', ',') +
						' ' +
						measures[measureIndex].suffix
					}
					pin={true}
					className="measure-range"
					onIonChange={updateInput}
					value={hip_circumference}
				/>
				<div className="measure-buttons">
					<IonButton
						shape="round"
						onClick={handleDecrease}
						disabled={isLoading}
						color="primary">
						-
					</IonButton>
					<IonButton
						shape="round"
						onClick={handleIncrease}
						disabled={isLoading}
						color="primary">
						+
					</IonButton>
				</div>
				<div className="buttons">
					<IonButton
						shape="round"
						onClick={handleSkip}
						disabled={isLoading}
						color="light-gray"
						expand="full">
						<IonText color="white">Salta</IonText>
					</IonButton>
					<IonButton
						shape="round"
						onClick={handleSubmit}
						disabled={isLoading}
						color="primary"
						expand="full">
						Avanti
					</IonButton>
				</div>
			</IonContent>
		</IonPage>
	)
}

export default HipCircunferencePace
